module.exports = __webpack_public_path__ + "Lato-Regular.ttf?3b9b99039cc0a98dd50c3cbfac57ccb2";